import { render } from "./ProductRowImage.vue?vue&type=template&id=1322b579&scoped=true"
import script from "./ProductRowImage.vue?vue&type=script&lang=js"
export * from "./ProductRowImage.vue?vue&type=script&lang=js"

import "./ProductRowImage.vue?vue&type=style&index=0&id=1322b579&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1322b579"]])

export default __exports__